import { SessionStore } from '../session.store';
import { JpgThema } from 'app/stores/bnr.document.store';
import { FocusThemaVM } from 'app/stores/ui/document.ui.store';
import { AgenturModel } from 'app/models/agentur.model';
import { JpgFocusThemenDef2025 } from 'app/components/documents/jpg/2025/JpgFocusThemenDef2025';
import { JpgFocusThemenDef2026 } from 'app/components/documents/jpg/2026/JpgFocusThemenDef2026';
import { AgtAdzeEmpfehlungVM } from './agt.adzempfehlung.ui.store';

export interface IJpgThemaDef {
	group: string;
	keyThema: string;
	themaShort: string;
	thema: string;
	byLine?: string;
	dataComponent?: (agt: AgenturModel, year: number) => JSX.Element;
	textComponent?: JSX.Element;
	handlungComponent?: JSX.Element;
	handlungsEmpfehlungen?: string[];
	missingDef?: string;
	background?: string;
	color?: string;
	bpKeys?: string[];
	adzKey?: string;
	sort?: number;
}

export const MissingDataView = (agt: AgenturModel, year: number) => {
	return <>Keine Fokus Themen Daten für {year}</>;
};

export const JpgTextDef: IJpgThemaDef = {
	group: 'Text',
	keyThema: 'text',
	themaShort: '',
	thema: 'Rückblick/Ausblick & Anhänge',
};

export const JpgZieleDef: IJpgThemaDef = {
	group: 'Ziele',
	keyThema: 'ziele',
	themaShort: '',
	thema: 'Ziele',
};

const getYearDef = (year: number) => {
	if (year === 2025) {
		return JpgFocusThemenDef2025;
	}
	if (year > 2025) {
		return JpgFocusThemenDef2026;
	}
	console.warn(' NO JPG FokusThemen Def for ' + year);
	return [];
};

export const mapFocusThemenToVM = (focusThemen: JpgThema[], year: number, adz?: AgtAdzeEmpfehlungVM) => {
	return focusThemen.map((f: JpgThema) => {
		const def = getYearDef(year).find((d) => d.keyThema === f.key);
		return new FocusThemaVM(def!, f, adz);
	});
};

export const mapFocusThemenByKeyToVM = (focusThemenKey: String[], year: number) => {
	return focusThemenKey.map((key) => {
		const def = getYearDef(year).find((d) => d.keyThema === key);
		const fakethema = new JpgThema({ key });
		return new FocusThemaVM(def!, fakethema);
	});
};

export const mapAllJpgThemenToVM = (focusThemen: JpgThema[], year: number, adz?: AgtAdzeEmpfehlungVM) => {
	return getYearDef(year).map((def: IJpgThemaDef) => {
		const f = focusThemen.find((t: JpgThema) => t.key === def.keyThema);
		return new FocusThemaVM(def, f, adz);
	});
};

export class JpgThemenUiStore {
	session: SessionStore;
	constructor(session: SessionStore) {
		this.session = session;
	}

	getThemenByYear(year: number) {
		return getYearDef(year);
	}
}
